
import FileResultCard from './FileResultCard.vue';
import MxModal from '@/components/global/MxModal.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IDataConsistencyRow, IFileTestResult, IFileTestResults, MediaType } from '@/types/resource.types';

@Component({
    name: 'FileModificationOverview',
    components: {
        FileResultCard,
        MxModal,
    }
})
export default class FileModificationOverview extends Vue {
    /* Props
    ============================================*/

    @Prop({ type: Object, default: () => ({ modificationResults: [], validationResults: [] }) })
    readonly testResults: IFileTestResults;

    @Prop({ type: Number, required: true })
    readonly mediaType: MediaType;

    @Prop({ type: Array, default: () => [] })
    readonly dataConsistency: IDataConsistencyRow[];

    /* Data
    ============================================*/

    modificationDetailsOpen: boolean = false;
    validationDetailsOpen: boolean = false;
    dataConsistencyOpen: boolean = false;

    /* Computed
    ============================================*/

    get showDataConsistency(): boolean {
        return this.mediaType === MediaType.Document || (this.dataConsistency != null && this.dataConsistency.length > 0);
    }

    get showModificationTests(): boolean {
        return !this.showDataConsistency;
    }

    get showValidationTests(): boolean {
        return this.mediaType === MediaType.Video;
    }

    get columnCount(): number {
        return this.showValidationTests ? 6 : 12;
    }

    get hasFindings(): boolean {
        return this.dataConsistency != null && this.dataConsistency.length > 0;
    }

    get allModificationTestsPassed(): boolean {
        return this.failedModificationResults.length === 0;
    }

    get allValidationTestsPassed(): boolean {
        return this.failedValidationResults.length === 0;
    }

    get modificationResults(): IFileTestResult[] {
        return this.testResults?.modificationResults ?? [];
    }

    get validationResults(): IFileTestResult[] {
        return this.testResults?.validationResults ?? [];
    }

    get failedModificationResults() {
        return this.modificationResults.filter(x => x.passed === false);
    }

    get failedValidationResults() {
        return this.validationResults.filter(x => x.passed === false);
    }

    /* Methods
    ============================================*/

    /* Lifecycle Hooks
    ============================================*/

    /* Watchers
    ============================================*/
}
